// Hooks
import { useAppSelector } from '../../../app/hooks';

// Features
import { selectSession } from '../../../features/session/sessionSlice';

// Models
import { Winner } from '../../../features/session/sessionModels';

// Components
import WinnersTable from '../WinnersTable/WinnersTable';

/**
 * @function SessionWinners
 * Describe the component's function
 *
 * @example
 * return (
 *   <SessionWinners winners={[]} />
 * )
 */
function SessionWinners({ winners }: SessionWinnersProps): JSX.Element {
    const session = useAppSelector(selectSession);

    return (
        <WinnersTable title="Winners">
            <tbody>
                {session?.games?.map(({ id, sort_order }) => {
                    const gameWinners = winners.filter(
                        ({ currentGameId }) => currentGameId === id,
                    );

                    return (
                        <tr key={id}>
                            <td>Game {sort_order}</td>
                            {gameWinners.length > 0 ? (
                                <>
                                    <td>
                                        {gameWinners.map(
                                            (
                                                { username, patternId },
                                                index,
                                            ) => (
                                                <span
                                                    key={`${id}-${patternId}`}
                                                >
                                                    {index !== 0 && ', '}
                                                    {username}
                                                </span>
                                            ),
                                        )}
                                    </td>
                                    <td>
                                        {gameWinners.map(
                                            ({ points, patternId }, index) => (
                                                <span
                                                    key={`${id}-${patternId}`}
                                                >
                                                    {index !== 0 && ', '}
                                                    {points} PP
                                                </span>
                                            ),
                                        )}
                                    </td>
                                </>
                            ) : (
                                <>
                                    <td>No winners this game!</td>
                                    <td>N/A</td>
                                </>
                            )}
                        </tr>
                    );
                })}
            </tbody>
        </WinnersTable>
    );
}

/**
 * @interface SessionWinnersProps
 * Describes the properties required for the SessionWinners component
 *
 * @property {array} winners
 */
export interface SessionWinnersProps {
    winners: Winner[];
}

// Exports
export default SessionWinners;
